var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("multiselect", {
        ref: "gameSelector",
        staticClass: "form-control",
        attrs: {
          options: _vm.gameOptions,
          "track-by": "key",
          multiple: true,
          taggable: true,
          label: "value"
        },
        on: { select: _vm.gameSelect, remove: _vm.gameRemove },
        scopedSlots: _vm._u([
          {
            key: "tag",
            fn: function(props) {
              return [
                _c("span", { staticClass: "multiselect__tag" }, [
                  _c("span", [_vm._v(_vm._s(props.option.value))]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "multiselect__tag-icon",
                    attrs: { "aria-hidden": "true", tabindex: "1" },
                    on: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.removeSelectedGameElement(props.option)
                      },
                      mousedown: function($event) {
                        $event.preventDefault()
                        return _vm.removeSelectedGameElement(props.option)
                      }
                    }
                  }),
                  _vm._v(" "),
                  props.option.key === "video-watching"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            color: "blue",
                            display: "inline-block"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addVideoUrl(props.option)
                            }
                          }
                        },
                        [
                          props.option.url !== null
                            ? [
                                _vm._v(
                                  "\n                        (" +
                                    _vm._s(props.option.url.slice(0, 10)) +
                                    ")\n                    "
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n                        (Video ekle)\n                    "
                                )
                              ]
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  props.option.key === "listen"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            color: "blue",
                            display: "inline-block"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.showListenModalEvent(props.option)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    (Karakter metni ekle)\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  props.option.key === "location-verification"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            color: "blue",
                            display: "inline-block"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addLocation(props.option)
                            }
                          }
                        },
                        [
                          props.option.location !== null
                            ? [
                                _vm._v(
                                  "\n                        (" +
                                    _vm._s(props.option.location) +
                                    ")\n                    "
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n                        (Lokasyon ekle)\n                    "
                                )
                              ]
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  props.option.key === "item-verification"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            color: "blue",
                            display: "inline-block"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addArtefact(props.option)
                            }
                          }
                        },
                        [
                          props.option.artefacts.length > 0
                            ? [
                                _vm._v(
                                  "\n                        (" +
                                    _vm._s(props.option.artefacts.length) +
                                    " Eser seçili)\n                    "
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n                        (Herhangi bir eser seçilmemiş)\n                    "
                                )
                              ]
                        ],
                        2
                      )
                    : _vm._e()
                ])
              ]
            }
          }
        ]),
        model: {
          value: _vm.selectedGames,
          callback: function($$v) {
            _vm.selectedGames = $$v
          },
          expression: "selectedGames"
        }
      }),
      _vm._v(" "),
      _c(
        "vue-final-modal",
        {
          key: "modal-1",
          attrs: {
            classes: "modal-container",
            "content-class": "modal-content"
          },
          model: {
            value: _vm.showSelectArtefactModal,
            callback: function($$v) {
              _vm.showSelectArtefactModal = $$v
            },
            expression: "showSelectArtefactModal"
          }
        },
        [
          _c(
            "span",
            { staticClass: "modal__title" },
            [
              _vm._t("title", function() {
                return [
                  _vm._v("\n                Lütfen eser seçiniz\n            ")
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal__content" },
            [
              _vm.showSelectArtefactModal
                ? _c("artefact-select-list", {
                    attrs: {
                      "create-hidden-input": false,
                      "selected-artefacts": _vm.selectedArtefactForGame
                    },
                    on: { "update-artefacts": _vm.updateArtefacts }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.showListenModal
        ? _c(
            "vue-final-modal",
            {
              key: "modal-2",
              attrs: {
                classes: "modal-container",
                "content-class": "modal-content"
              },
              model: {
                value: _vm.showListenModal,
                callback: function($$v) {
                  _vm.showListenModal = $$v
                },
                expression: "showListenModal"
              }
            },
            [
              _c(
                "span",
                { staticClass: "modal__title" },
                [
                  _vm._t("title", function() {
                    return [
                      _vm._v(
                        "\n                Lütfen karakter metini giriniz.\n            "
                      )
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal__content" },
                _vm._l(_vm.languages, function(language, lnKey) {
                  return _c("div", { key: lnKey }, [
                    _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-sm-1 col-form-label" }, [
                        _vm._v(
                          "\n                        Metin [" +
                            _vm._s(language.key) +
                            "]\n                        "
                        ),
                        language.key === "tr_TR"
                          ? _c("p", { staticClass: "fs-6 text-danger" }, [
                              _vm._v(
                                "\n                            *Zorunlu\n                        "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-11" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOption.text[language.key],
                                expression: "selectedOption.text[language.key]"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              rows: "5",
                              name: "language"
                            },
                            domProps: {
                              value: _vm.selectedOption.text[language.key]
                            },
                            on: {
                              change: function($event) {
                                return _vm.setCharacterMessageChanged(
                                  _vm.selectedOption,
                                  language.key
                                )
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.selectedOption.text,
                                  language.key,
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          language.key !== "tr_TR"
                            ? _c("span", { staticClass: "fs-6 text-info" }, [
                                _vm._v(
                                  "Bu alanı boş bırakmanız halinde metin\n                                Google Translate'den otomatik\n                                çevrilir."
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                }),
                0
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22682946", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22682946","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/vue/story-visiting-point-game-select.vue
// module id = 93
// module chunks = 0